export default {
  methods: {
    formatShortDescription(str: string) : string {
      return str.replace(/<[^>]*>?/gm, '')
    },
  }
}